<template>
  <div>
    <b-row class="m-0">
        <b-col class="p-0">
        <fieldset class="border p-3">
            <legend  class="w-auto bg-facebook px-2 py-1 text-white rounded border h6">Employee Awards  <font-awesome-icon icon="plus-circle" class="ml-3 cursor-pointer" @click="award_modal=true" /></legend>
                <table class="table table-bordered mt-2 mb-0 table-sm">
                    <thead class="thead-dark">
                        <tr>
                            <th scope="col">Award</th>
                            <th scope="col" class="text-center">Date Awarded</th>
                            <th scope="col" class="text-center">Remarks</th>
                            <th scope="col" class="text-center">Action</th>
                        </tr>
                    </thead>
                    <tbody class="bg-white text-dark">
                        <tr v-for="(manpower_award, index) in params.form.manpower_awards">
                            <td>
                                <strong>{{manpower_award.award.description}}</strong>
                            </td>
                            <td class="text-center">
                                {{manpower_award.date_formatted.other_formats.format_1}}
                            </td>
                            <td>
                                {{manpower_award.remarks}}
                            </td>
                            <td class="text-center">
                                <b-button size="sm" variant="danger" @click="deleteAward(manpower_award.id)"><font-awesome-icon icon="minus-circle" /> Remove</b-button>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </fieldset>

        </b-col>
    </b-row>

      <b-modal v-model="award_modal" centered size="md" body-class="p-0" :hide-footer="true" :hide-header="true">
          <award-form @save="save"/>
      </b-modal>
  </div>
</template>
<script>

    import SwalMixin from "@/views/mixins/Swal.js";
    import AwardForm from './AwardForm.vue';
    import NumberFormatComponent from '@/views/helpers/NumberFormatComponent.vue';
    export default {
        mixins:[SwalMixin],
        components: {NumberFormatComponent,AwardForm},
        props:{
            params: {
                type: Object,
                default: {},
                required: true
            },
        },
        data() {
            return {
                award_modal:false,
            }
        },
        methods:{
            deleteAward(id){
                this.swalConfirmDelete((data)=>{
                    if (data.value) {
                        this.is_saving=true;
                        this.axios.delete('maintenance/manpowers/awards/delete',{ data: {id:id} }).then(response => {
                            this.swalTransactionCompleted();
                            this.is_saving=false;
                            this.$emit('save');
                        }).catch(error => {
                            this.swal_transaction_error_data.text = error.response.data;
                            this.swalRequestError();
                            this.is_saving=false;
                        });
                    }
                });

            },
            save(){
                this.$emit('save');
                this.award_modal=false;
            },
        }
    }
</script>
